// composables/gamification/mocks.ts
//
// Client-only demo fixtures for ephemeral reward feedback (M4C-29). They stand in
// for live action responses (M4C-35) so the star-born modal + activity toasts can
// be exercised via the dev-only `?reward=` trigger
// (`useGamificationService().triggerMockRewardFeedback()`). Components consume the
// service, never this file.
//
// The constellation / progress / activity READ fixtures that used to live here were
// removed once the authenticated-self reads went live against m4c-api (M4C-44 —
// `gamification/overview|activity|actions`); the public per-member read fixtures
// were removed in M4C-43.

import type { RewardFeedbackInput } from '@/types/gamification';

/* ------------------------------------------------------------------ */
/* Reward feedback (ephemeral demo fixtures, M4C-29)                   */
/* ------------------------------------------------------------------ */

// Sample reward events for development/demo before live action responses exist
// (M4C-35). The star-born event references a constellation/star id; with the reads
// now live the modal resolves geometry from the live API and degrades gracefully
// (gold-star hero, no preview) when a demo id has no live match. Nothing here is
// persisted. Emitted via `useGamificationService().triggerMockRewardFeedback()`.

/** A just-born star — drives the star-born celebration modal. */
export const mockStarBornFeedback: RewardFeedbackInput = {
  kind: 'star_born',
  title: 'The star was born.',
  constellation_id: 'c-lyra',
  star_id: 'lyra-3',
  stars_delta: 1,
};

/** Stacked activity toasts — mirrors the Figma fragment toasts + a star milestone. */
export const mockToastFeedback: RewardFeedbackInput[] = [
  { kind: 'fragments_gained', title: 'Account created', fragments_delta: 5 },
  { kind: 'fragments_gained', title: 'Declaration of Interests added', fragments_delta: 5 },
  { kind: 'fragments_gained', title: 'Onboarding completed', fragments_delta: 10 },
  {
    kind: 'milestone',
    title: 'First star raised!',
    constellation_id: 'c-lyra',
    star_id: 'lyra-3',
    stars_delta: 1,
  },
];
